import React, { useEffect, useState, useCallback } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Fade,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CampaignIcon from "@mui/icons-material/Campaign";
import sh from "bundles/common/utils/sh";
import AnnouncementContent from "./AnnouncementContent";

const AnnouncementModal = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    sh.get("/internal/announcements/latest")
      .then((res) => {
        if (res.data?.id) {
          setAnnouncement(res.data);
          setOpen(true);
        }
      })
      .catch(() => {});
  }, []);

  const handleDismiss = useCallback(() => {
    if (!announcement?.id) return;
    setOpen(false);
    sh.post(`/internal/announcements/${announcement.id}/dismiss`).catch(() => {});
  }, [announcement]);

  if (!announcement) return null;

  return (
    <Dialog
      open={open}
      onClose={handleDismiss}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Fade}
      transitionDuration={250}
      PaperProps={{
        sx: {
          borderRadius: "1rem",
          overflow: "hidden",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          background: "linear-gradient(135deg, hsl(150 38% 17%) 0%, hsl(150 30% 22%) 100%)",
          px: 3,
          py: 2.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <CampaignIcon sx={{ color: "hsl(80 97% 72%)", fontSize: 28 }} />
          <Typography
            variant="h6"
            sx={{
              color: "#fff",
              fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
              fontSize: 18,
            }}
          >
            What&apos;s New
          </Typography>
        </Box>
        <IconButton onClick={handleDismiss} sx={{ color: "rgba(255,255,255,0.7)" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      <DialogContent
        sx={{
          px: 3,
          py: 3,
          maxHeight: "50vh",
          overflowY: "auto",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
            color: "hsl(150 30% 12%)",
            mb: 2,
          }}
        >
          {announcement.title}
        </Typography>

        <AnnouncementContent text={announcement.description} />
      </DialogContent>

      {/* Footer */}
      <DialogActions sx={{ px: 3, pb: 3, pt: 0 }}>
        <Button
          onClick={handleDismiss}
          fullWidth
          disableRipple
          sx={{
            textTransform: "none",
            fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
            fontSize: 15,
            py: 1.25,
            borderRadius: "0.75rem",
            backgroundColor: "hsl(150 38% 17%)",
            color: "hsl(80 97% 72%)",
            "&:hover": {
              backgroundColor: "hsl(150 30% 22%)",
            },
          }}
        >
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnnouncementModal;
